import { GET_BEST_SELLER_SUCCESS, GET_BEST_SELLER_FAIL } from '../types';
const initialStata = {
  loading: false,
  bestSeller: []
};
export default function bestSellerReducer(state = initialStata, { type, payload }) {
  switch (type) {
    case GET_BEST_SELLER_SUCCESS:
      return {
        ...state,
        bestSeller: payload
      };
    case GET_BEST_SELLER_FAIL:
      return {
        ...state,
        error: payload
      };
    default:
      return {
        ...state
      };
  }
}
